/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  Signal,
  ViewChild,
  ViewContainerRef,
  WritableSignal,
} from '@angular/core';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { Observable, map } from 'rxjs';
import { InViewportModule } from 'ng-in-viewport';
import { AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CategoryPickerComponent } from '../components/category-picker/category-picker.component';
import { Params } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { BestDealsPickerComponent } from '../components/best-deals-picker/best-deals-picker.component';
import { UiSkeletonComponent } from '../../shared/components/ui-skeleton/ui-skeleton.component';

import { HighlightsBannerComponent } from '../components/highlights-banner/highlights-banner.component';
import { FooterComponent } from '@app/shared/components/new-footer/footer.component';
import { AkitaRemoteConfigQuery } from '@app/akita/api/remote-config/state/remote-config.query';
import { BestCategoryDealsPickerComponent } from '../components/best-category-deals-picker/best-category-deals-picker.component';
import { BESTDEALS_FAQ_DATA } from './frequent-faq.data';
import { AkitaConfigurationQuery } from '@app/akita/configuration/state/configuration.query';
import { ChevronDownIconComponent } from '../../shared/components/icons/generated/chevron-down/chevron-down.component';
import { NavigationBarComponent } from '@app/home-new/components/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-best-deals-view',
  templateUrl: './best-deals.view.template.html',
  styleUrls: ['./best-deals.view.style.scss'],
  imports: [
    TranslocoModule,
    CategoryPickerComponent,
    InViewportModule,
    NavigationBarComponent,
    AsyncPipe,
    FooterComponent,
    UiSkeletonComponent,
    HighlightsBannerComponent,
    BestDealsPickerComponent,
    BestCategoryDealsPickerComponent,
    ChevronDownIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestDealsViewComponent {
  @ViewChild('componentWrapper', { read: ViewContainerRef })
  public componentWrapper!: ViewContainerRef;

  public readonly biggerThan$: Observable<ScreenSizeInfoState>;

  public readonly isBrowser: boolean;
  public readonly isRestoringScroll: Signal<boolean>;

  public enableBuybackFeature: Signal<boolean | null> = signal(null);

  public faqData = BESTDEALS_FAQ_DATA;
  public lang: string;

  public testHomePage: Signal<string | null>;
  public scrollToPosition: WritableSignal<boolean> = signal(false);

  public priceBannerLoaded = false;
  public categoryPickerLoaded = false;
  public feedbackBannerLoaded = false;
  public tabSelectorLoaded = false;
  public bestSellersLoaded = false;
  public whyBannerLoaded = false;
  public refurbishedBannerLoaded = false;
  public reviewsBannerLoaded = false;
  public footerLoaded = false;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaRemoteConfigQuery: AkitaRemoteConfigQuery,
    private readonly akitaConfigurationQuery: AkitaConfigurationQuery
  ) {
    this.isBrowser = this.akitaRouterQuery.isBrowser;
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.isRestoringScroll = toSignal(this.akitaRouterQuery.selectIsRestoringScroll(), {
      initialValue: false,
    });

    this.lang = (this.akitaConfigurationQuery.languageCode.locale || 'EN').toUpperCase();

    this.enableBuybackFeature = toSignal(
      this.akitaRemoteConfigQuery.selectEnableBuybackFeature(),
      {
        initialValue: null,
      }
    );

    this.testHomePage = toSignal(
      this.akitaRouterQuery.selectParamsAndQueryParams().pipe(
        map((params: Params): string | null => {
          // testing page
          if (params.t) {
            return params.t;
          }
          return null;
        })
      ),
      { initialValue: null }
    );
  }
}
